<template>
  <div
    v-ripple
    class="base-card-item center-right"
    @click="$emit('click-card')"
  >
    <slot name="title-icon">
      <svg-icon
        v-if="hasTitleIcon"
        name="wallet-2"
        color="#08284D"
        style="margin-left: 10px"
      ></svg-icon>
    </slot>

    <slot name="title-text">
      <span class="subtitle2-medium title-text">
        {{ titleText }}
      </span>
    </slot>

    <v-spacer></v-spacer>

    <slot name="action-text">
      <span v-if="actionText && !loading" class="body2-regular action-text">
        {{ actionText }}
      </span>
      <loading :width="38.25" :height="22.5" v-if="loading"></loading>
    </slot>

    <slot name="action-icon">
      <svg-icon
        name="chevron-left"
        color="rgba(0, 0, 0, 0.6)"
        class="mr-3"
      ></svg-icon>
    </slot>
  </div>
</template>

<script>
export default {
  name: "BaseCardAction",
  props: {
    hasTitleIcon: {
      type: Boolean,
      default: false,
      required: false,
    },

    titleText: {
      type: String,
      default: "",
      required: false,
    },

    actionText: {
      type: String,
      default: "",
      required: false,
    },

    loading: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
};
</script>

<style scoped>
.base-card-item {
  width: 100%;
  height: auto;
  background-color: #ffffff;
  padding: 14px 15px;
  margin: 0;
  cursor: pointer;
}

.center-right {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.title-text {
  color: rgba(0, 0, 0, 0.6);
}

.action-text {
  color: #1565c0;
}
</style>
